"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromEvent = void 0;
var _Observable = require("./Observable");
var fromEvent = exports.fromEvent = function fromEvent(element, eventname, options) {
  return (0, _Observable.mkObservable)(function (observer) {
    var callback = function callback(e) {
      return observer.next(e);
    };
    element.addEventListener(eventname, callback, options);
    return function () {
      return element.removeEventListener(eventname, callback);
    };
  });
};